import { z } from 'zod';

/**
 * Schema for $day route parameter
 * Validates that day is a positive integer
 */
export const dayParamSchema = z.object({
  day: z.coerce.number().positive().int(),
});

export type TDayParams = z.infer<typeof dayParamSchema>;

export const stepParamSchema = z.object({
  step: z.coerce.number().positive().int(),
});

export type TStepParams = z.infer<typeof stepParamSchema>;
